import { ISettingsParam } from 'tslog';
import { RolesPermission } from '../enums/RolesPermissionList';

export const PRIVACY_POLICY: string =
  'https://www.cisco.com/c/en/us/about/legal/privacy-full.html';
export const TERMS_SERVICES: string =
  'https://www.cisco.com/c/dam/en_us/about/doing_business/legal/Cisco_General_Terms.pdf';
export const CLAIM_NUMBER_DOCUMENTATION_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/admin/95947.dita';

export const CLAIM_NUMBER_DOCUMENTATION_LINK_GOV: string =
  'https://securitydocs.cisco.com/docs/scc/piam/gov/158651.dita';

export const DOCUMENTATION_LINK_SINGLE_TENANCY: string =
  'https://securitydocs.cisco.com/docs/scc/admin/106362.dita';

export const CONTACT_SUPPORT_DOCUMENTATION_LINK: string =
  'https://www.cisco.com/c/en/us/support/web/tsd-cisco-worldwide-contacts.html';

export const CONTACT_SUPPORT_LINK: string =
  'https://www.cisco.com/c/en/us/support/index.html';

export const CISCO_SUPPORT_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/admin/107888.dita';

export const SUBSCRIPTION_MOVEMENT_MODAL_SUPPORT_LINK: string =
  'https://www.cisco.com/c/en/us/support/index.html';
export const CUSTOMER_SUPPORT_LINK: string =
  'https://securitydocs.cisco.com/api/v0/apps?appId=SccPlatformReleaseNotes&topic=customer-support';

export const CISCO_CONFIG_GUIDE_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/admin/106191.dita';

export const CISCO_REGION_SELECTION_GUIDE: string =
  'https://securitydocs.cisco.com/docs/scc/admin/95914.dita';

export const CISCO_ENTERPRISE_DOCUMENTATION_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/admin/95917.dita';

export const CISCO_ENTERPRISE_GOV_DOCUMENTATION_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/piam/gov/158640.dita';

export const CISCO_SECURITY_CLOUD_CONTROL_USER_GUIDE: string =
  'https://securitydocs.cisco.com/docs/scc/admin/95952.dita';

export const CISCO_IDP_GROUPS_DOCUMENTATION: string =
  'https://securitydocs.cisco.com/docs/scc/admin/97397.dita';

export const CISCO_IDENTITY_PROVIDER_SETUP_GUIDE_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/admin/95895.dita';

export const SASE_DOCUMENTATION_LINK: string =
  'https://securitydocs.cisco.com/docs/scc/admin/95939.dita';

export const SECURE_WORKLOAD_ROLES_DOCUMENTATION =
  'https://www.cisco.com/c/en/us/td/docs/security/workload_security/secure_workload/user-guide/3_9/cisco-secure-workload-user-guide-saas-v39/settings.html#concept_853093';

export const CISCO_MSP_REVOKE_RELATIONSHIP_CONTACT_SUPPORT_LINK: string =
  'https://securitydocs.cisco.com/api/v0/apps?appId=SccPlatformReleaseNotes&topic=customer-support';

export const CISCO_SSE_PRODUCT = 'Cisco Secure Access'; // CSESC-3390.
/**
 * Strictly used uppercase to avoid String case-issue FEATURE_FLAG_PREFIX constant.
 **/
export const FEATURE_FLAG_PREFIX = 'MERCURY-FF-';

// API error handling
export const X_TRACE_ID_RESPONSE_HEADER = 'x-trace-id';
export const X_PROMETHEUS_TRACE_ID_RESPONSE_HEADER = 'x-amzn-requestid';
export const GENERIC_ERROR = 'genericError';

export const LOGGER_DB_NAME: string = 'LoggerDataBase';
export const LOGGER_TABLE_NAME: string = 'Logger';
export const LEGACY: string = 'legacy';
export const EXTERNAL: string = 'external';
export const LOGGER_CONFIGURATION_PARAMETERS: ISettingsParam<any> = {
  name: 'PIAM-Logger',
  type: 'hidden',
  prettyLogTemplate:
    '{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}\t {{logLevelName}}\t[{{name}}]\t',
  prettyErrorTemplate:
    '\n{{errorName}} {{errorMessage}}\nerror stack:\n{{errorStack}}',
  prettyErrorStackTemplate:
    '  • {{fileName}}\t{{method}}\n\t{{filePathWithLine}}',
  prettyErrorParentNamesSeparator: ':',
  prettyErrorLoggerNameDelimiter: '\t',
  stylePrettyLogs: true,
  prettyLogTimeZone: 'UTC',
  prettyLogStyles: {
    logLevelName: {
      SILLY: ['bold', 'white'],
      TRACE: ['bold', 'whiteBright'],
      DEBUG: ['bold', 'green'],
      INFO: ['bold', 'blue'],
      WARN: ['bold', 'yellow'],
      ERROR: ['bold', 'red'],
      FATAL: ['bold', 'redBright'],
    },
    dateIsoStr: 'white',
    filePathWithLine: 'green',
    name: ['black', 'bold'],
    nameWithDelimiterPrefix: ['green', 'bold'],
    nameWithDelimiterSuffix: ['white', 'bold'],
    errorName: ['bold', 'bgRedBright', 'whiteBright'],
    fileName: ['yellow'],
  },
};

export const MIN_TABLE_PAGE_SIZE = 30;
export const PAGE_SIZE_OPTIONS = [MIN_TABLE_PAGE_SIZE, 50, 100];
export const TABLE_CONFIG = {
  pagination: true,
  paginationConfig: {
    pageSize: MIN_TABLE_PAGE_SIZE,
    showPageSizeChanger: true,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
  },
};

export const EXTERNAL_SUB_QUERY_PARAM_VALUE = 'external';
export const EXTERNAL_SUB_QUERY_PARAM_KEY = 'sub';
export const SECURITY_CLOUD_CONTROL_READ_ONLY =
  'Security Cloud Control-Read Only';

export const READ_ONLY_GROUP_NAME = 'Global ReadOnly';

export const dummyCert =
  'MIIDHTCCAgWgAwIBAgIJWc055/vMRWESMA0GCSqGSIb3DQEBCwUAMCwxKjAoBgNVBAMTIWRldi1za2V3OGQ1eDZuZzd6YmwzLnVzLmF1dGgwLmNvbTAeFw0yMjExMjkwNzE1MDNaFw0zNjA4MDcwNzE1MDNaMCwxKjAoBgNVBAMTIWRldi1za2V3OGQ1eDZuZzd6YmwzLnVzLmF1dGgwLmNvbTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAMLSSNe68gNRuApDOQD6FGyfyYDzzptpY2czyx2+WEu5PDXtAzsV9GPo3gWiNdnfwceafYJbD2KEkAwpR5OW3IPsyyQThDI0mR5P2r1+M1q3dj8dKahZ8pY/J40xTmPUpNx0LbFKvYODQTwU3eWcG15rYoHTwPvhfvW+Qivz18D5Mq+LXG5k9TSNMjYDIu6/iX/pk/n1SEIrUJXeg0722X5KzMBNRd5lrhXTnQ79OZbZpn0im4WY+CeK4PY4dMxzmPq+vl+Qf6BArT2ksFKnIZnowT/GVj6KRHFLzIytetL/hCcn4M8ikcLhB7ukAzsaL4GbSGkucoMynNWOadJNr+MCAwEAAaNCMEAwDwYDVR0TAQH/BAUwAwEB/zAdBgNVHQ4EFgQUI2nbLPM6uw37+4XwdGtCWF8Vka0wDgYDVR0PAQH/BAQDAgKEMA0GCSqGSIb3DQEBCwUAA4IBAQBfXO38WrZcUsk5X0uQMJgfaKgbT/8H6BU55X9d4wPA7PxNaG9uMAlgUW6BJKqg2E9MK3OIaS5cxtw00914dg01OqmlFVXIxFh7h3S0hZVak+4g1sTS1UIBY6gXHOCfSForJOXk/UeXWaSetMqgRK+Rd/sNH47E1iXnMc8G6ppmJIasJKizy7s0LP9c11YXFfma/F8ftDRqb6ZQU979CCqo+5DTSn5Uvsf7JwIrWPP38r86XUsGCLFqfLhn/83vAnidaGwHtiXfDEcGWo0CoPDJaGXqSqtmmSi/vpihzFWlr/0PCgqlHP7FxsJ2bzKyBNV6dcvjkOamYFzsLU+yCxRe';

/**
 * Strictly used uppercase to avoid String case-issue.
 **/
export const FEATURE_FLAG_CONSTANTS = {
  ENTERPRISE_NAVIGATION: 'ENTERPRISE-NAVIGATION',
  ACCESS_ENTERPRISE_BY_URL: 'ACCESS-ENTERPRISE-BY-URL',
  USER_INVITE_FLOWS: 'USER-INVITE-FLOWS',
  ADD_GROUP: 'ADD-GROUP',
  EDIT_GROUP: 'EDIT-GROUP',
  USER_ROLES_LIST: 'USER-ROLES-LIST',
  USER_MANAGEMENT: 'USER-MANAGEMENT',
  PERMISSION_AND_CUSTOM_ROLE_MANAGEMENT:
    'PERMISSION-AND-CUSTOM-ROLE-MANAGEMENT',
  MAP_IDP_GROUPS: 'MAP-IDP-GROUPS',
  EXTERNAL_IDP: 'EXTERNAL-IDP',
  CLAIM_CODE_MANAGEMENT: 'CLAIM-CODE-MANAGEMENT',
  BUNDLED_ROLE: 'BUNDLED-ROLE',
  ROLES_MANAGEMENT_DELEGATION: 'ROLES-MANAGEMENT-DELEGATION',
  INTEGRATIONS_MFE: 'INTEGRATIONS-MFE',
  SUBSCRIPTION_UI: 'SUBSCRIPTION-UI',
  UNIFIED_ONBOARDING: 'UNIFIED-ONBOARDING',
  ENHANCE_CUSTOM_ROLE_FOR_CSW: 'ENHANCE_CUSTOM_ROLE_FOR_CSW',
  UNIFIED_ONBOARDING_II: 'UNIFIED-ONBOARDING-II',
  IAM_SYSTEM_GROUPS_10194: 'IAM-SYSTEM-GROUPS-10194',
  SINGLE_TENANT_PER_ORG_UI: 'SINGLE-TENANT-PER-ORG-UI',
  SUBSCRIPTION_LIST_VIEW: 'SUBSCRIPTION-LIST-VIEW',
  SINGLE_SECURE_ACCESS: 'SINGLE-SECURE-ACCESS',
  MULTI_ORG: 'MULTI-ORG',
  NON_JIT_STATIC_MESSAGES: 'NON-JIT-STATIC-MESSAGES',
  SINGLE_TENANT_ORG_ENTITLEMENTS: 'SINGLE-TENANT-ORG-ENTITLEMENTS',
  UNIFIED_ONBOARDING_III: 'UNIFIED-ONBOARDING-III',
  ALLOW_INITIAL_ADMIN: 'ALLOW-INITIAL-ADMIN-CR',
  SCC_READ_ONLY: 'SCC-READ-ONLY',
  SCC_READ_ONLY_GROUP: 'SCC-READ-ONLY-GROUP',
  UNIFIED_ONBOARDING_SERVICES_UPGRADE: 'UNIFIED-ONBOARDING-SERVICES-UPGRADE',
  PROVISIONING_MVC_UPGRADE: 'PROVISIONING-MVC-UPGRADE',
  SUBSCRIPTIONS_VIEW_MVC_UPGRADE: 'SUBSCRIPTIONS-VIEW-MVC-UPGRADE',
  SUBSCRIPTIONS_DRAWER_MVC_UPGRADE: 'SUBSCRIPTIONS-DRAWER-MVC-UPGRADE',
  ENTERPRISE_EDIT_MVC_UPGRADE: 'ENTERPRISE-EDIT-MVC-UPGRADE',
  ROLE_ENTERPRISE: 'ROLE-ENTERPRISE',
  SHARE_GROUPS_TO_MANAGED_ORGS: 'SHARE-GROUPS-TO-MANAGED-ORGS',
  MSP_ORG_DETAILS: 'MSP-ORG-DETAILS',
  SUBSCRIPTIONS_TITLE_UPDATES: 'SUBSCRIPTIONS-TITLE-UPDATES',
  ON_DEMAND_MCD: 'ON-DEMAND-MCD',
  ENABLE_TRIAL_ON_PAID_AUTO_REVERT: 'ENABLE-TRIAL-ON-PAID-AUTO-REVERT',
  DISPLAY_ADDONS: 'DISPLAY-ADDONS',
  MSP_PARTNER_SCOPED_LICENSE_SHARING: 'MSP-PARTNER-SCOPED-LICENSE-SHARING',
  MSP_RESTRICT_SHARED_GROUP_ACCESS: 'MSP-RESTRICT-SHARED-GROUP-ACCESS',
  USER_INVITE_EXAMPLE_FILE: 'USER-INVITE-EXAMPLE-FILE',
  RESEND_EMAIL_21768: 'RESEND-EMAIL-21768',
  MSP_ASSIGN_ROLE_WITHOUT_INSTANCE: 'MSP-ASSIGN-ROLE-WITHOUT-INSTANCE',
  SUBSCRIPTION_MOVEMENT: 'SUBSCRIPTION-MOVEMENT',
  ENABLE_FIREWALL_ACTION: 'ENABLE-FIREWALL-ACTION',
  ENABLE_FEDRAMP_SCCv3_FIREWALL: 'ENABLE_FEDRAMP_SCCv3_FIREWALL',
  ENABLE_MCD_CONTROLLER_ENABLEMENT: 'enable-mcd-controller-enablement',
  ENABLE_MAINTENANCE_MODE: 'ENABLE-MAINTENANCE-MODE',
  ENABLE_CDO_MSP_MULTI_ORG_PROVISIONING:
    'ENABLE-CDO-MSP-MULTI-ORG-PROVISIONING',
  ENABLE_DISPLAY_DUO_MESSAGING: 'enable-display-duo-messaging',
  MSP_SUBSCRIPTION_ENHANCEMENTS: 'MSP-SUBSCRIPTION-ENHANCEMENTS',
  ENABLE_NEXTGEN_SASE: 'ENABLE-NEXTGEN-SASE',
  ENABLE_CUI_MFE: 'enable-cui-mfe',
  ENABLE_MPE: 'ENABLE-MPE',
  SUBSCRIPTION_MOVEMENT_DRAWER: 'SUBSCRIPTION-MOVEMENT-DRAWER',
  ENABLE_SA_AUS_ADDON: 'ENABLE-SA-AUS-ADDON',
};

export const Trial = {
  name: 'trial',
  size: 'sm',
  dataTestId: 'ontrial-flag',
  tagContent: 'overview:trial',
  color: 'accentA',
};
export const InActive = {
  name: 'inactive',
  size: 'sm',
  dataTestId: 'inactive-flag',
  tagContent: 'overview:inActive',
  status: 'disabled',
};
export const Provisioned = {
  name: 'provisioned',
  size: 'sm',
  dataTestId: 'provisioned-tag',
  tagContent: 'overview:pendingStatus',
  status: 'warning',
};
export const Legacy = {
  name: 'legacy',
  size: 'sm',
  tagContent: '',
  dataTestId: 'is-legacy-externally-managed-flag',
};
export const External = {
  name: 'external',
  size: 'sm',
  tagContent: '',
  dataTestId: 'is-legacy-externally-managed-flag',
};

export const Activated = {
  name: 'activated',
  size: 'sm',
  tagContent: 'overview:activatedStatus',
  dataTestId: 'activated-tag',
  status: 'positive',
};

export const NoStatus = {
  name: 'nostatus',
  size: 'sm',
  tagContent: '-',
  dataTestId: 'no-status-tag',
};

export const status = { activated: 'Activated', inavtive: 'Inactive' };

export const EA = {
  name: 'ea',
  size: 'sm',
  tagContent: 'overview:licenseType:ea',
  dataTestId: 'ea-license-type',
};

export const ALC = {
  name: 'alc',
  size: 'sm',
  tagContent: 'overview:licenseType:alc',
  dataTestId: 'alc-license-type',
};

export const MSLA = {
  name: 'msla',
  size: 'sm',
  tagContent: 'overview:licenseType:msla',
  dataTestId: 'msla-license-type',
};

export const MSEA = {
  name: 'msea',
  size: 'sm',
  tagContent: 'overview:licenseType:msea',
  dataTestId: 'msea-license-type',
};

export const ExpiringSoon = {
  name: 'expiring-soon',
  size: 'sm',
  tagContent: 'overview:expiringSoon',
  dataTestId: 'expiring-soon-tag',
  color: 'accentC',
  status: 'warning',
};
export const Hibernated = {
  name: 'hibernated',
  size: 'sm',
  tagContent: 'overview:hibernated',
  dataTestId: 'hibernated-tag',
};
export const Hibernated_On_Card = {
  name: 'hibernated',
  size: 'sm',
  tagContent: 'overview:hibernated',
  dataTestId: 'hibernated-tag',
  status: 'in-progress',
};
// will uncomment this in next userstory
// export const Expired = {
//   name: 'expired',
//   size: 'sm',
//   tagContent: 'overview:expired',
//   dataTestId: 'expired-tag',
//   status: 'negative',
// };

export const ENTERPRISE = 'Organization';

export const ENTERPRISE_PRODUCT_NAME = 'Security Cloud Control';

export const productNameMap: Record<string, string> = {
  'Identity Intelligence': 'Cisco Identity Intelligence',
  'Integrations Service': 'Cisco Integrations Service',
  'Cisco Duo': 'Cisco Identity Intelligence',
};

export const ORGANIZATION_ADMINISTRATOR = 'Organization Administrator';
export const ALL_PRODUCT_ADMINISTRATOR = 'All Product Administrator';

export const ENTERPRISE_PRODUCT_ADMINISTRATOR_ROLE_NAME = `${ENTERPRISE_PRODUCT_NAME} - ${RolesPermission.ADMINISTRATOR}`;

export const ENTERPRISE_PRODUCT_TYPE = 'enterprise';

export const ENTERPRISE_OPTIONS = [
  { value: ENTERPRISE, label: ENTERPRISE, selected: true, disabled: true },
];

export const ENTERPRISE_ADMIN_ROLE = {
  id: RolesPermission.ADMINISTRATOR,
  productKey: ENTERPRISE_PRODUCT_TYPE,
  roleDisplayName: ORGANIZATION_ADMINISTRATOR,
  name: RolesPermission.ADMINISTRATOR,
  product: ENTERPRISE_PRODUCT_NAME,
  delegatable: false,
  isProductProvisioned: true,
  featureFlags: null,
  roleDescription: RolesPermission.ADMINISTRATOR,
};

export const products = [
  {
    id: '377dccc5-866b-44e3-8e6c-3b83daa25fc9',
    name: 'Cisco Secure Workload',
    region: { name: 'EU', description: 'Europe' },
  },
  {
    id: 'ead7204c-cda6-46d5-a516-731be896e5f7',
    name: 'Cisco Multicloud Defense',
    region: { name: 'APJC', description: 'Asia Pacific, Japan and China' },
  },
];

export const productsOrgEntitlements = [
  {
    productName: 'Cloud Defense Orchestrator',
    productId: '1234',
    selectedRegion: { label: 'North America', value: 'NAM' },
    availableDeploymentRegion: { label: 'North America', value: 'NAM' },
    isTrial: false,
  },
];

export const servicesOrgEntitlements = [
  {
    productName: 'Test CI Services',
    productId: '2345',
    selectedRegion: { label: 'North America', value: 'NAM' },
    availableDeploymentRegion: { label: 'North America', value: 'NAM' },
    attachExternalTenant: true,
  },
];

export const productsDataOrgEntitlements = [
  {
    id: '1234',
    name: 'Cloud Defense Orchestrator',
    region: { name: 'NAM', description: 'North America' },
  },
];
export const servicesDataOrgEntitlements = [
  { id: '2345', name: 'Test CI Services', is_use_existing_tenant_set: true },
];

export const tablePaginationConfigWithoutPageSizeChanger = {
  pageSize: 10,
  showPageSizeChanger: false,
};

export const APPLICATION_PORTAL_LINK =
  'https://apps.security.cisco.com/overview';

export const FIREWALL_PRODUCT_TYPE = 'cdo';
export const MCD_PRODUCT_TYPE = 'mcd';
export const MPE_PRODUCT_TYPE = 'mpe';

export const SYSTEM = 'System';
export const BUNDLED = 'Bundled';
export const CII_SERVICE_ID = '9';
export const TEST_CII_SERVICE_ID = '34';
export const CISCO_DUO_PRODUCT = 'Cisco Duo';
export const TEST_CII_PRODUCT = 'Test CII Product 1';
export const CISCO_CDO_PRODUCT =
  'Cisco Security Cloud Control Firewall Management';
export const CISCO_XDR_PRODUCT = 'Cisco XDR';
export const CISCO_AI_ASSISTANT_PRODUCT = 'Cisco AI Assistant';
export const CISCO_MCD_PRODUCT = 'Cisco Multicloud Defense';
export const CISCO_MPE_PRODUCT = 'Cisco Mesh Policy Engine';
export const MESH_POLICY_ENGINE = 'Mesh Policy Engine';
export const CISCO_AI_DEFENCE_PRODUCT = 'Cisco AI Defense';
export const claimCodeRegex = /^[A-Za-z-]+$/;
export const CISCO_DUO = 'cisco duo premier';
export const CISCO_DUO_SERVICE = 'cisco duo premier service';
export const CISCO_IDENTITY_INTELLIGENCE = 'cisco identity intelligence';
export const DUO_WITH_IDENTITY_INTELLIGENCE =
  'Cisco Duo + Identity Intelligence';
export const CISCO_CATALYST_SD_WAN = 'Cisco Catalyst SD-WAN';
export const CISCO_SASE_PRODUCT = 'Cisco Catalyst SASE Management';
export const SASE_PRODUCT_NAME = 'Cisco SASE Management';
export const CATALYST_SD_WAN = 'Catalyst SD-WAN';
export const SASE = 'SASE (Secure Access Service Edge)';

export const SUBSCRIPTIONS_REVIEW_CONSTANTS = {
  CLAIM_HEADING: 'Claim Subscription',
  CANCEL_HEADING: 'Cancel Subscription Claim',
  CANCEL_ON_REVIEW_MODAL: 'CancelOnReviewModal',
  CLAIM_ATTEMPTED: 'claimAttempted',
  RETURN_ON_CANCEL_MODAL: 'ReturnOnCancelModal',
  CANCEL_ON_CANCEL_MODAL: 'CancelOnCancelModal',
  CANCEL: 'cancel',
  RETURN_TO_CLAIM: 'return to claim',
  CANCEL_CLAIM: 'cancel claim',
};

export const hiddenProductsManagementOrg = new Set([
  'secure-access',
  'enterprise',
  'cdo',
]);

export const MSP_CONSTANTS = {
  multiOrgManager: 'MULTIORG_MANAGER',
  mspManager: 'MSP_MANAGER',
  multiOrgManaged: 'MULTIORG_MANAGED',
  mspManaged: 'MSP_MANAGED',
  standalone: 'STANDALONE',
  trailClaimError: 'trial claim is blocked for manager org',
  invalidSkuError: 'MSP claim subscription not allowed for provided SKU',
  managedEnterpriseType: 'MANAGED', // Normalized value of managed enterprise type
};

export const SECURE_ACCESS_CONSTANTS = {
  internetEssentials: 'Internet Essentials',
  privateEssentials: 'Private Essentials',
  internetAdvantage: 'Internet Advantage',
  privateAdvantage: 'Private Advantage',
};

export const secure_access_SKUs = new Map<string, string>([
  ['SA-SIA-ESS-K9', SECURE_ACCESS_CONSTANTS.internetEssentials],
  ['SA-SPA-ESS-K9', SECURE_ACCESS_CONSTANTS.privateEssentials],
  ['SA-SIA-ADV-K9', SECURE_ACCESS_CONSTANTS.internetAdvantage],
  ['SA-SPA-ADV-K9', SECURE_ACCESS_CONSTANTS.privateAdvantage],
  ['E3S-SA-SIA-ESS', SECURE_ACCESS_CONSTANTS.internetEssentials],
  ['E3S-SA-SPA-ESS', SECURE_ACCESS_CONSTANTS.privateEssentials],
  ['E3S-SA-SIA-ADV', SECURE_ACCESS_CONSTANTS.internetAdvantage],
  ['E3S-SA-SPA-ADV', SECURE_ACCESS_CONSTANTS.privateAdvantage],
  ['SA-SIA-NR-ESS-K9', SECURE_ACCESS_CONSTANTS.internetEssentials],
  ['SA-SPA-NR-ESS-K9', SECURE_ACCESS_CONSTANTS.privateEssentials],
  ['SA-SIA-NR-ADV-K9', SECURE_ACCESS_CONSTANTS.internetAdvantage],
  ['SA-SPA-NR-ADV-K9', SECURE_ACCESS_CONSTANTS.privateAdvantage],
]);

export const MSP_TABS = { DETAILS: 'details', ORGANIZATION: 'organization' };

export const DeepLinks = {
  mspOrgDetailsPage: (managedOrgId?: string): string => {
    return `/msp/org-details/${managedOrgId}`;
  },
} as const;

export const ALL_MANAGED = 'All managed organizations';
export const SOME_MANAGED = 'Some managed organizations';
export const ADMIN = 'Admin';
export const COMMERCIAL_PROD_URL = 'https://security.cisco.com';

export const DUO_DOCUMENTATION_URL: string =
  'https://securitydocs.cisco.com/docs/duo/everywhere/solution/160003.dita';

export const TEST_ORG_PRODUCT_A = 'TEST-ORG-PRODUCT-A';
export const TEST_ORG_PRODUCT_B = 'TEST-ORG-PRODUCT-B';
export const TEST_ORG_PRODUCT_C = 'TEST-ORG-PRODUCT-C';
export const TEST_ORG_PRODUCT_D = 'TEST-ORG-PRODUCT-D';
export const TEST_ORG_PRODUCT_MSP_A = 'TEST-ORG-PRODUCT-MSP-A';
export const TEST_ORG_PRODUCT_MSP_B = 'TEST-ORG-PRODUCT-MSP-B';
export const TEST_ORG_PRODUCT_MSP_C = 'TEST-ORG-PRODUCT-MSP-C';
export const TEST_ORG_PRODUCT_MSP_D = 'TEST-ORG-PRODUCT-MSP-D';
